import React from "react";
import { useSiteContext } from "../../../../../context/SiteContext";
import { useEditCtaContext } from "../../../../../context/EditCtaContext";

const VerticalTemplateOneOneFive = ({
  titleText = "ONE OF\nA KIND",
  titleFont = "Helvetica",
  titleFontSize = "36",
  titleColor = "#E6E7EB",
  titleTextAlign = "center",
  titleIsBold = true,
  titleIsItalic = false,
  titleIsUnderline = false,

  subtitleText = "Two reasons to buy it",
  subtitleFont = "Helvetica",
  subtitleFontSize = "14",
  subtitleColor = "#FFFFFF",
  subtitleTextAlign = "center",
  subtitleIsBold = false,
  subtitleIsItalic = false,
  subtitleIsUnderline = false,

  // Acts as the middle panel background
  backgroundType = "color",
  backgroundColor = "#0B0F14",
  backgroundImage = null,

  buttonLabel = "More Info",
  buttonFont = "Helvetica",
  buttonIsBold = true,
  buttonIsItalic = false,
  buttonIsUnderline = false,
  buttonLink = "",
  buttonFontSize = "16",
  buttonFontColor = "#FFFFFF",
  buttonBackgroundColor = "#C03BFF",

  // Optional overrides for images
  contentImageTop = "/oneoneFiveCar.png",
  contentImageBottom = "/oneoneFiveBottom.png",

  backgroundImagePreview,

  preview = false,
  inmeeting = false,
  onClose,
  position = "left",
}) => {
  const { meetingRole, setActiveElement } = useSiteContext();
  const { explicitBoleanCheck } = useEditCtaContext();
  const isMobile = typeof window !== "undefined" && window.innerWidth <= 767;

  return (
    <div
      className={`relative ${
        !inmeeting ? "h-full" : isMobile ? "h-full" : "!h-[89vh] mt-[30%] w-72"
      } ${
        isMobile && inmeeting
          ? position === "left" || position === "right"
            ? "" // Let it size naturally
            : "w-full" // Fill container for center/top/bottom
          : "w-72"
      } flex flex-col mx-auto justify-between items-center  overflow-hidden`}
      style={{ backgroundColor }}
    >
      {/* Close Button */}
      {inmeeting && (
        <button
          className="absolute top-2 right-2 z-20 bg-red-500 hover:bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center transition-colors"
          title="Close Banner"
          style={{ right: "8px", top: "8px" }}
          onClick={() => {
            if (meetingRole === "moderator") {
              onClose();
            } else {
              setActiveElement(null);
            }
          }}
        >
          <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      )}

      {/* Top image */}
      <div
        className="w-full h-32 md:h-40"
        style={{
          backgroundImage: `url(${contentImageTop})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />

      {/* Middle panel */}
      <div
        className="w-full py-6 px-4 flex flex-col items-center justify-center gap-4"
        style={{ backgroundColor }}
      >
        <h1
          className={`text-center ${
            explicitBoleanCheck(titleIsBold) ? "font-bold" : ""
          } ${explicitBoleanCheck(titleIsItalic) ? "italic" : ""} ${
            explicitBoleanCheck(titleIsUnderline) ? "underline" : ""
          }`}
          style={{
            color: titleColor,
            fontSize: `${titleFontSize}px`,
            fontFamily: titleFont,
            textAlign: titleTextAlign,
            lineHeight: "1.05",
            whiteSpace: "pre-line",
          }}
        >
          {titleText}
        </h1>

        <div
          className={`text-center ${
            explicitBoleanCheck(subtitleIsBold) ? "font-bold" : ""
          } ${explicitBoleanCheck(subtitleIsItalic) ? "italic" : ""} ${
            explicitBoleanCheck(subtitleIsUnderline) ? "underline" : ""
          }`}
          style={{
            color: subtitleColor,
            fontSize: `${subtitleFontSize}px`,
            fontFamily: subtitleFont,
            textAlign: subtitleTextAlign,
            opacity: 0.95,
          }}
        >
          {subtitleText}
        </div>

        <button
          className={`px-6 py-2 rounded-full transition-all duration-200 shadow-lg hover:shadow-xl ${
            buttonLink ? "cursor-pointer" : "cursor-default"
          }`}
          style={{
            backgroundColor: buttonBackgroundColor,
            color: buttonFontColor,
            fontSize: `${buttonFontSize}px`,
            fontFamily: buttonFont,
            fontWeight: explicitBoleanCheck(buttonIsBold) ? "bold" : "normal",
            fontStyle: explicitBoleanCheck(buttonIsItalic) ? "italic" : "normal",
            textDecoration: explicitBoleanCheck(buttonIsUnderline) ? "underline" : "none",
          }}
          onClick={() => {
            if (buttonLink) {
              window.open(buttonLink, "_blank");
            }
          }}
        >
          {buttonLabel}
        </button>
      </div>

      {/* Bottom image */}
      <div
        className="w-full h-32 md:h-40"
        style={{
          backgroundImage: `url(${contentImageBottom})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
    </div>
  );
};

export default VerticalTemplateOneOneFive;


